import React, { Component, createRef } from "react"
import MetaTags from 'react-meta-tags';
import PropTypes from 'prop-types'
import { Link } from "react-router-dom"
import { connect } from "react-redux"
import { withTranslation } from "react-i18next"
import {  map, isEmpty, size } from "lodash";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Formik, Field, Form, ErrorMessage, FieldArray } from "formik";
import * as Yup from "yup";
import Moment from 'react-moment';
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import Swal from 'sweetalert2'
import classnames from "classnames"
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete';
import deleteIcon from "../../assets/images/icons/bin.png";
import icon1  from "../../assets/img/message-icon.png";
import icon2 from "../../assets/img/documents-icon.png";
import icon3 from "../../assets/img/appointment-icon.png";
import { MultiSelect } from "primereact/multiselect";
import { InputText } from "primereact/inputtext";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  FormGroup,
  Label,
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Collapse,
  CardHeader,
    Table
} from "reactstrap"
import { API_URL } from "helpers/api_url";
import axios from "axios";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import CurrencyFormat from "react-currency-format";
import moment from "moment";
import RsLink from "components/Buttons/rsLink";
class helpLinkPage extends Component {
  constructor(props) {
    super(props)
    this.state = {
      helpCategories: [],
      links: []
    
    }
     this.dt = createRef();
  }
   fetchCategory() {
        const obj = JSON.parse(localStorage.getItem("authUser"));
        const token = obj?.resultData?.bearerToken;
        const headers = {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        };
        const params = {
          agentId: localStorage.getItem("agentId"),
          clientId: localStorage.getItem("userId")
        };
        axios
          .get(`${API_URL}HelpCategory/allforagent`, { headers, params })
          .then((response) => {
            this.setState({ helpCategories: response.data, loading: false });
          })
          .catch((error) => {
            this.setState({ error: error.message, loading: false });
          });
      }
      fetchLinks() {
        const obj = JSON.parse(localStorage.getItem("authUser"));
        const token = obj?.resultData?.bearerToken;
        const headers = {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        };
        const params = {
          agentId: localStorage.getItem("agentId"),
        };
        axios
          .get(`${API_URL}AgentHelpfulLink/allAgent`, { headers, params })
          .then((response) => {
            this.setState({ links: response.data, loading: false });
          })
          .catch((error) => {
            this.setState({ error: error.message, loading: false });
          });
      }
 componentDidMount() {
        this.fetchCategory();
        this.fetchLinks();
      }
  render() {
    const { loading, helpCategories, links } = this.state;
    return (
      <React.Fragment>
        {loading ? (
         <div className="loading">Loading&#8230;</div>
         ) : null}
        <ToastContainer autoClose={2000} />
       
        <div className="page-content">
          <MetaTags>
            <title>Seller Showings  | Realty Space</title>
          </MetaTags>
          <Container fluid>
             {/* <Breadcrumbs
              title={this.props.t("Seller")}
              breadcrumbItem={this.props.t("Seller Showings ")}
            /> */}
              <Row className="justify-content-between align-items-center mb-4">
                            <Col sm="12">
                              <Nav tabs className="projectTab pref-tab">
                                <NavItem>
                                  <Link className="nav-link " to="/support">
                                    <span className="d-flex align-items-center gap-2">
                                      Professional Network
                                      <img src={icon1} height={16} />
                                    </span>
                                  </Link>
                                </NavItem>
                                <NavItem>
                                  <Link className="nav-link active" to="/helpful-links">
                                    <span className="d-flex align-items-center gap-2">Helpful links
            
                                       <img src={icon2} height={16} />
                                    </span>
                                  </Link>
                                </NavItem>
                                <NavItem>
                                  <Link className="nav-link" to="/helpful-documents">
                                     <span className="d-flex align-items-center gap-2">Documents
            
                                      <img src={icon3} height={16} />
                                     </span>
                                  </Link>
                                </NavItem>
                              </Nav>
                            </Col>
                          </Row>
            <Row>
              
              
              <Col xl="12">
          
			  <Row>
				<Col sm="12">
					 <Card className="rs-card-bg"> 
                      
                    <CardBody>
                    
				

          

                            <DataTable
                              className=""
                            
                              stripedRows
                              value={links}
                             
                              paginator
                              rows={10}
                              rowsPerPageOptions={[10, 20, 30, 50, 100, 150, 200, 500]}
                              currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                              paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                              tableStyle={{ minWidth: "50rem" }}
                            >
                              <Column
                                    field="helpfulLinkCategory"
                                    header="Type"
                                    body={(rowData) =>
                                        helpCategories.find((opt) => opt.id === rowData.helpfulLinkCategory)?.helpCategoryTitle || ""
                                    }
                                   
                                    />
                               <Column
                                field="helpfulLinkTitle"
                                header="Name"
                              />
                            <Column
                                field=""
                                header=""
                                body={(rowData) =>
                                        <a href={rowData.helpfulLinkUrl} target="_blank" rel="noreferrer"> View</a>
                                    }
                                
                              />
                             
                                    
                             
                            </DataTable>
					</CardBody>
					</Card>
				</Col>
			</Row>
			
			
            </Col>
            
            </Row>
           
          </Container>
         
        </div>
      </React.Fragment>
    )
  }
}
helpLinkPage.propTypes = {
  t: PropTypes.any,
  history:PropTypes.object

}
const mapStateToProps = ({  }) => (
  {
     
   

  })
const mapDispatchToProps = dispatch => ({
 
 
});
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(helpLinkPage))
